import './widget.css';
const getStationURL = 'https://api.weather.gov/points/';
// when compiled based on environment
let environment = "cloud";
if(document.currentScript.src.includes("staging")) {
  environment = "staging";
};
if(document.currentScript.src.includes("staging2")) {
  environment = "staging2";
};
if(document.currentScript.src.includes("prod")) {
  environment = "prod";
};
if(document.currentScript.src.includes("dev") || document.currentScript.src.includes("local")|| document.currentScript.src.includes("192.168.7.209")) {
  environment = "dev";
};

const backEndGetIconsAPIAddr = `https://${environment}.screenbeam.com/api/signage/icons`;
const backEndGetAnalogClockFace = `https://${environment}.screenbeam.com/api/signage/analog-clock-face.svg`;
// const testIP = '10.0.0.7';
// const backEndGetIconsAPIAddr = `https://${testIP}:3001/api/signage/icons`;
// const backEndGetAnalogClockFace = `https://${testIP}:3001/api/signage/analog-clock-face.svg`;

const getDateOptions = {
  timeZone: '',
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
};
var getTimeOptions = {
  timeZone: '',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
};
// Map digits to their names (this will be an array)
const digit_to_name = 'zero one two three four five six seven eight nine'.split(' ');
// Positions for the hours, minutes, and seconds
const digitalClockPositions = ['h1', 'h2', ':', 'm1', 'm2'];

/**
 * weather widget function
 * @param {*} paramters 
 * @returns 
 */
export async function getWeatherWidget(paramters) {
  console.log('*****************getWeatherWidget called with parameters:', paramters);
  return await getWeather(paramters.lat, paramters.lon)
  .then((res)=> {
      console.log('weathers:', res);
      let weatherInfo = null;
    if(res || res.periods || res.periods.length > 0) {
        weatherInfo = res.periods[0];
      }

    if(weatherInfo){
        let bgClass = 'weather-widget-bg';
        let iconURL = '';
        let iconName = new URL(weatherInfo.icon).pathname.split('/').filter(Boolean).pop();
        iconName = iconName.split(',')[0];
        // Check if the icon URL contains 'day' or 'night'
      if(weatherInfo.name && weatherInfo.name.includes('Night') ||
          weatherInfo.icon && weatherInfo.icon.includes('night')) {
          iconName += '_night';
          bgClass = 'weather-widget-bg-night';
        }

        iconURL = `${backEndGetIconsAPIAddr}/${iconName}.svg`;
        console.log(`********iconName:${iconName}******weatherInfo.iconURL:${iconURL}***weatherInfo. timezone:${res.timeZone}*******`);

        let date = new Date();
        getDateOptions.timeZone = res.timeZone;
        const dateText = date.toLocaleString('en-US', getDateOptions);

        return createModule(
          bgClass,
          paramters.city, // City
          dateText, // Date
          iconURL, // Icon URL
          `${weatherInfo.temperature}${weatherInfo.temperatureUnit}`, // Temperature
          weatherInfo.shortForecast // Short Forecast
        );
      }
      return;
    })
    .catch(error => console.error(error));
}

async function getWeather(lat, lon) {
  try {
    console.log(`*****************getWeather called with lat:${lat}  lon:${lon}`);

    //get the weather station by lat and lon
    const stationData = await getWeatherStation(lat, lon);
    console.log('******************getWeather called with stationData.properties.timeZone:', stationData.properties.timeZone);
    const forecastUrl = stationData.properties.forecast; // get weather forecast URL from station data

    //get the weather forecast from the URL
    const forecast = await getForecast(forecastUrl);
    return ({periods:forecast.properties.periods, timeZone: stationData.properties.timeZone}); // return the periods of the forecast
  } catch (error) {
    console.error('get weather failed:', error);
    throw error;
  }
}

async function getWeatherStation(lat, lon) {
  const response = await fetch(getStationURL + `${lat},${lon}`);
  if (!response.ok) throw new Error('getWeatherStation failed: ' + response.statusText);
  return await response.json();
}

async function getForecast(forecastUrl) {
  const response = await fetch(forecastUrl);
  if (!response.ok) throw new Error('getForecast failed: ' + response.statusText);
  return await response.json();
}

function createModule(bgClass, cityText, dateText, iconURL, temperatureText, shortForecastText) {
  return `
    <div class="weather-widget ${bgClass}">
           <div class="weather-main-info">
             <div class="row location-info">
               <span class="location-city" id="weather-">${cityText}</span>
               <span class="location-date">${dateText}</span>
             </div>
             <div class="row weather-info">
                  <div class="weather-icon">
                    <img src="${iconURL}" alt="weather icon" />
                  </div>
                 <div class="weather-temperature">${temperatureText}</div>
                <div class="weather-short-forecast">${shortForecastText}</div>
             </div>
           </div>
    </div>
  `;
}

/**
 * Digital Clock widget function
 * @param {*} paramters 
 * @returns 
 */
export function getDigitalClockWidget(widgetName, widgetContainer, paramters)
{
  widgetContainer.appendChild(createDigitalClockMoudle(widgetName));
  updateDigitalClock(widgetName, paramters);
}
function createDigitalClockMoudle(widgetName)
{
  //div id=clock
  var divClock = document.createElement('div');
  divClock.setAttribute('id', 'clock');
  divClock.classList.add('digital-clock-widget');

  //div digits
  var divDigits = document.createElement('div');
  divDigits.classList.add('clock-main-info', 'digits');
  divClock.appendChild(divDigits);

  //div time hh:mm
  digitalClockPositions.forEach((type) =>{
    var timeDiv = document.createElement('div');
    timeDiv.setAttribute('id', widgetName + '-' + type);
    if(type == ':'){
      timeDiv.classList.add('dots');
    }
    else{
      for(var i=1; i<8; i++){
        var timeIconsDiv = document.createElement('span');
        timeIconsDiv.classList.add('d-' + i);
        timeDiv.appendChild(timeIconsDiv);
      }
    }
    divDigits.appendChild(timeDiv);
  });
  return divClock;
}

function updateDigitalClock(widgetName, paramters)
{
  let date = new Date();

  getTimeOptions.timeZone = paramters.timeZone;
  getTimeOptions.hour12 = paramters.format;

  var nowTime = date.toLocaleString('en-US', getTimeOptions);

  //update div time hh:mm
  digitalClockPositions.forEach((type, index) =>{
    if(type != ':'){
      var timeElement = document.getElementById(widgetName + '-' + type);
      //over old class
      if(timeElement){
        timeElement.setAttribute('class',  digit_to_name[nowTime[index]]);
      }
    }
  });
}

/**
 * Analog Clock widget function
 * @param {*} paramters 
 * @returns 
 */
export function getAnalogClockWidget(widgetName, widgetContainer, paramters) {
  widgetContainer.appendChild(createAnalogClockMoudle(widgetName));
  updateAnalogClock(widgetName, paramters);
}
function createAnalogClockMoudle(widgetName) {
  //div id=analog-clock
  var divClock = document.createElement('div');
  divClock.setAttribute('id', 'analog-clock');
  divClock.classList.add('analog-clock-widget');

  //div analog-clock-main-info
  var divMainInfo = document.createElement('div');
  divMainInfo.classList.add('analog-clock-main-info');
  divClock.appendChild(divMainInfo);

  //image clock face
  var imgClockFace = document.createElement('img');
  imgClockFace.setAttribute('src', backEndGetAnalogClockFace);
  divMainInfo.appendChild(imgClockFace);

  //div center dot
  var divCenterDot = document.createElement('div');
  divCenterDot.classList.add('center-dot');
  divMainInfo.appendChild(divCenterDot);

  //div hour-hand
  var divHourHand = document.createElement('div');
  divHourHand.setAttribute('id', widgetName + '-hour-hand');
  divHourHand.classList.add('hand', 'hour-hand');
  divMainInfo.appendChild(divHourHand);

  //div minute-hand
  var divMinuteHand = document.createElement('div');
  divMinuteHand.setAttribute('id', widgetName + '-minute-hand');
  divMinuteHand.classList.add('hand', 'minute-hand');
  divMainInfo.appendChild(divMinuteHand);

  //div second-hand
  var divSecondHand = document.createElement('div');
  divSecondHand.setAttribute('id', widgetName + '-second-hand');
  divSecondHand.classList.add('hand', 'second-hand');
  divMainInfo.appendChild(divSecondHand);

  return divClock;
}

export function updateAnalogClock(widgetName, paramters) {
  console.log(`updateAnalogClock called with widgetName: ${widgetName} and parameters: ${JSON.stringify(paramters)}`);
  const now = new Date();
  const timeStr = now.toLocaleString('en-US', { timeZone: paramters.timeZone });
  //console.log(` timeStr = ${timeStr}`);
  const currentDate = new Date(timeStr);
  //console.log(` ${currentDate}`);
  const hours = currentDate.getHours() % 12;
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();

  const hourDegrees = (hours * 30) + (minutes * 0.5); // 360 / 12 = 30 degrees per hour, plus 0.5 degrees per minute
  const minuteDegrees = minutes * 6; // 360 / 60 = 6 degrees per minute
  const secondDegrees = seconds * 6; // 360 / 60 = 6 degrees per second

  /*
  document.getElementById(`${widgetName}-hour-hand`).querySelector('.hour-hand').style.transform = `rotate(${hourDegrees}deg)`;
  document.getElementById(`${widgetName}-minute-hand`).querySelector('.minute-hand').style.transform = `rotate(${minuteDegrees}deg)`;
  document.getElementById(`${widgetName}-second-hand`).querySelector('.second-hand').style.transform = `rotate(${secondDegrees}deg)`;
  */
  const hourHand = document.querySelector(`#${widgetName}-hour-hand`);
  if (hourHand) {
    hourHand.style.transform = `rotate(${hourDegrees}deg)`;
  }

  const minuteHand = document.querySelector(`#${widgetName}-minute-hand`);
  if (minuteHand) {
    minuteHand.style.transform = `rotate(${minuteDegrees}deg)`;
  }

  const secondHand = document.querySelector(`#${widgetName}-second-hand`);
  if (secondHand) {
    secondHand.style.transform = `rotate(${secondDegrees}deg)`;
  }
}


/**
 * Calendar widget function
 * @param {*} paramters 
 * @returns 
 */
export function getCalendarWidget(widgetName, widgetContainer, paramters){
  console.log("*********getCalendarWidget************")
  const timeZoneVar = paramters.timeZone;
  const now = new Date();
  const timeStr = now.toLocaleString('en-US', { timeZone: timeZoneVar });
  const currentDate = new Date(timeStr);
  console.log("currentDate = " + currentDate)


  const monthYear = now.toLocaleDateString('en-US', { timeZone: timeZoneVar, year: 'numeric', month: 'long'});
  console.log("month = " + monthYear)
  widgetContainer.innerHTML = createCalendarModule(widgetName, monthYear);

var testing = now.toLocaleDateString('en-US', { timeZone: timeZoneVar, year: 'numeric', month: 'long', weekday: 'long'});
  console.log("testing = " + testing);
  console.log("currentDate = " + currentDate);

  //Get days from previous month to display
  const prevMonthDays = getPrevMonthDays(currentDate, timeZoneVar);
  console.log("prev month days=" + prevMonthDays);

  // Get days in current month
  const currentMonthDays = getDaysInMonth(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1
  );

  // Get days from next month to display
  const nextMonthDays = 42 - (prevMonthDays + currentMonthDays); // 6 weeks

  // Create day elements
  createDayElements(widgetName, timeZoneVar, currentDate, prevMonthDays, currentMonthDays, nextMonthDays);

}
function getPrevMonthDays(date, timeZoneVar) {
  //Get the firstDay of currect month
  const firstDayIndex = new Date(date.getFullYear(), date.getMonth(), 1);
  return firstDayIndex.getDay();
}
function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

function createCalendarModule(widgetName, monthYear)
{
  return `
  <div class="calendar-widget">
    <div class="calendar-main-info">
      <div class="calendar-header">
        <h2 class="month-year">${monthYear}</h2>
      </div>
      <div class="calendar-weekdays">
        <div class="red">Sun</div>
        <div>Mon</div>
        <div>Tue</div>
        <div>Wed</div>
        <div>Thu</div>
        <div>Fri</div>
        <div class="red">Sat</div>
      </div>
      <div id="${widgetName}-calendar-days" class="calendar-days"></div>
    </div>
  </div>
  `;
}
function createDayElements(widgetName, timeZoneVar, currentDate, prevMonthDays, currentMonthDays, nextMonthDays) {
  // Previous month days
  var prevMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1
  );
  const timeStr = prevMonth.toLocaleString('en-US', { timeZone: timeZoneVar });
  prevMonth = new Date(timeStr);
  const prevMonthTotalDays = getDaysInMonth(
    prevMonth.getFullYear(),
    prevMonth.getMonth() + 1
  );
      console.log("*****prevMonthTotalDays=*****"+prevMonthTotalDays);
  var daysContainer = document.getElementById(`${widgetName}-calendar-days`);
         console.log("*****prevMonthTotalDays=**222222***"+prevMonthTotalDays);
  for (let i = prevMonthTotalDays - prevMonthDays + 1; i <= prevMonthTotalDays; i++) {
        console.log("*****prevMonthTotalDays=**33333***"+prevMonthTotalDays);
    daysContainer.appendChild(createDayElement(i, 'other-month'));
  }

  // Current month days
  for (let i = 1; i <= currentMonthDays; i++) {
    const isToday =
      i === currentDate.getDate() &&
      currentDate.getMonth() === currentDate.getMonth() &&
      currentDate.getFullYear() === currentDate.getFullYear();

    daysContainer.appendChild(createDayElement(i, isToday ? 'today' : ''));
  }

  // Next month days
  for (let i = 1; i <= nextMonthDays; i++) {
    daysContainer.appendChild(createDayElement(i, 'other-month'));
  }
}

function createDayElement(dayNum, className) {
  var dayElememnt = document.createElement('div');
  dayElememnt.classList.add('calendar-day');
  if (className) dayElememnt.classList.add(className);
  dayElememnt.textContent = dayNum;

  // Add click event
  /*dayElememnt.addEventListener('click', () => {
    document.querySelectorAll('.day.selected').forEach(el => {
      el.classList.remove('selected');
    });
    if (!dayElememnt.classList.contains('other-month')) {
      dayElememnt.classList.add('selected');
    }
  });*/
  return dayElememnt;
}